<div class="sidebar-height">
  <div class="company-logo" [routerLink]="homeLink">
    <div class="shrink-width-logo">
      <img class="inline-block cursor-pointer sidebar-closed-logo flex-shrink-0" [src]="closedLogo" alt="">
    </div>
    <!-- <img class="inline-block cursor-pointer sidebar-cross-logo flex-shrink-0" [src]="closeIcon" alt=""> -->
    <img class="inline-block cursor-pointer sidebar-logo flex-shrink-0" [src]="openLogo" alt="">
  </div>
  <div class="sidebar-body hide-scrollbar">
    <p-panelMenu class="sidebar-panel-menu " [model]="items" [multiple]="true"></p-panelMenu>
  </div>
  <div class="version-info text-center privacy-contact text-gray-500 pt-3 pl-3 flex justify-center items-center gap-2">
    <div class="flex items-center gap-2 relative">
      <div class="text-right akesa-logo-open">
        <div class="privacy-contact font-italic text-white mr-4"> Powered by </div>
        <img class="cursor-pointer privacy-contact" [src]="akesaLogo" alt="">
      </div>
      <img class="cursor-pointer akesa-logo-closed" [src]="akesaSmallLogo" alt="">
    </div>
    <button type="button" class="p-button p-button-text flex items-center gap-2"
      (click)="navigateTo('https://akesagroup.com/privacy-policy/')">
      <i class="mi-lg mi-about-us"></i>
      <span class="privacy-contact" translate>sidebar_privacy_policy</span>
    </button>

    <span class="content-seperator">|</span>

    <button type="button" class="p-button p-button-text flex items-center gap-2"
      (click)="navigateTo('https://akesagroup.com/contact/')">
      <i class="mi-lg mi-contact-support"></i>
      <span class="privacy-contact" translate>sidebar_contact_us</span>
    </button>

  </div>
  @if(isSidebarBodyReady){
    <div class="app-version-info text-center text-sm pb-2 mb-3">
      v{{appVersion}}
    </div>
  }
</div>